import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

const chaseUnderline = keyframes`
  0% { transform: translateX(-78%); }
  100% { transform: translateX(78%); }
`;

const ConnectSection = styled.section`
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'RobotoMono', sans-serif;
`;

const SectionTitle = styled.h2`
  font-size: clamp(2em, 5vw, 3em);
  margin-bottom: 40px;
  background: linear-gradient(135deg, #a855f7 0%, #d4a1ff 50%, #f0abfc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
  text-align: center;
  position: relative;
  padding-bottom: 16px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 14%;
    right: 14%;
    bottom: 0;
    height: 2px;
    border-radius: 999px;
    background: linear-gradient(90deg, transparent, #d4a1ff, #f0abfc, transparent);
    transform: translateX(-78%);
    animation: ${chaseUnderline} 2.2s linear infinite;
  }

  &::after {
    animation-delay: 1.1s;
    opacity: 0.7;
  }
`;

const ConnectGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); // 3 columns for a balanced look
  gap: 25px;
  width: 90%;
  max-width: 1200px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const ConnectCard = styled.a`
  text-decoration: none;
  background: rgba(25, 18, 40, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(168, 85, 247, 0.3);
  border-radius: 20px;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-10px);
    border-color: #a855f7;
    background: rgba(168, 85, 247, 0.1);
    box-shadow: 0 10px 30px rgba(138, 43, 226, 0.3);
    
    .icon {
      animation: ${float} 2s ease-in-out infinite;
      color: #fff;
    }
  }

  .icon {
    font-size: 3rem;
    color: #d4a1ff;
    margin-bottom: 15px;
    transition: all 0.3s ease;
  }

  .label {
    color: #fff;
    font-weight: 600;
    font-size: 1.2rem;
    letter-spacing: 1px;
  }

  .sub-label {
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.8rem;
    margin-top: 5px;
  }
`;

const SocialLinks: React.FC = () => {
  const socialData = [
    { icon: <FaGithub className="icon" />, label: "GitHub", sub: "Check out my projects", url: "https://github.com/cmell05" },
    { icon: <FaLinkedin className="icon" />, label: "LinkedIn", sub: "Let's connect!", url: "https://www.linkedin.com/in/carmellasetiabudi"},
    { icon: <FaEnvelope className="icon" />, label: "Email", sub: "Drop me a message!", url: "mailto:carmella0502@gmail.com" }
  ];

  return (
    <ConnectSection id="connect">
      <SectionTitle>Connect With Me</SectionTitle>
      <ConnectGrid>
        {socialData.map((item, index) => (
          <ConnectCard 
            key={index} 
            href={item.url} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            {item.icon}
            <span className="label">{item.label}</span>
            <span className="sub-label">{item.sub}</span>
          </ConnectCard>
        ))}
      </ConnectGrid>
    </ConnectSection>
  );
};

export default SocialLinks;
